import {
	mapState,
	mapGetters,
	mapActions
} from 'vuex';

import vSelect from 'vue-select';
import moment from 'moment';

import {
	EventBus
} from '@/support/event-bus';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
	state,
	actions,
	getters,
	mutations,
	name: 'students',
	components: {
		vSelect
	},
	data: () => ({
		student: [],
		studentList: []
	}),
	props: {
		context: {
			type: String,
			default: ''
		},
		className: {
			type: String,
			default: ''
		},
		imglist: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState({
			classes: (state) => state.Class,
			students: (state) => state.Student.list,
			agenda: (state) => state.Agenda
		}),
		...mapGetters({
			currentStudent: 'getStudent',
			user: 'getLoggedUser',
			class: 'getClass',
			album: 'album'
		})
	},
	filters: {
		agendaStatus: (value) => {

			return {
				NOT_CREATED: 'Não criada',
				CREATED: 'Criada',
				IN_APPROVAL: 'Em aprovação',
				IN_REVISION: 'Em revisão',
				PROCESSING: 'Processando',
				REPROCESS: '',
				APPROVED: 'Publicada',
				SENT: 'Enviada',
				READED: 'Lida'
			}[value];

		}
	},
	methods: {
		...mapActions([
			'getStudents',
			'setStudent',
			'getAgenda',
			'getAgendaStatus',
			'getMessages',
			'getPresence',
			'getMessageRecipient',
			'getMessageRecipientIsResponsible',
			'setMessageRecipientResponsible',
			'setMessageRecipientList',
			'setMessageRecipientSchoolMembers',
			'setSchoolMembers',
			'setResponsibles',
			'updateStudentList'
		]),
		setCurrentStudent(student) {

			EventBus.$emit('setStudent');

			this.setStudent(student);

			if (this.context === 'agenda') {

				this.getAgenda({
					userId: this.user.id,
					studentId: student.studentId,
					date: moment(this.agenda.date).format('YYYY-MM-DD')
				}).then(() => {
					EventBus.$emit('setAgenda');
				});

				this.getMessages({
					userId: this.user.id,
					studentId: student.studentId,
				});

			}

			if (this.context === 'newmessage') {

				this.getMessageRecipient({
					userId: this.user.id,
					studentId: student.studentId,
				}).then(() => {

					this.getMessageRecipientIsResponsible(true).then((response) => {
						this.setMessageRecipientResponsible(response);
					});

					this.getMessageRecipientIsResponsible(false).then((response) => {
						this.setMessageRecipientSchoolMembers(response);
					});

				});

			}

			if (this.context === 'gallery') {
				this.student = this.album.students;
			}

		},
		getStatusLabelColor(status) {

			const redClass = 'bg-red-flamingo bg-font-red-flamingo';
			const yellowClass = 'bg-yellow-lemon bg-font-yellow-lemon';
			const grayClass = 'bg-grey-salsa bg-font-grey-salsa';
			const greenClass = 'bg-green-jungle bg-font-green-jungle';

			return {
				'NOT_CREATED': redClass,
				'CREATED': yellowClass,
				'IN_APPROVAL': yellowClass,
				'IN_REVISION': redClass,
				'PROCESSING': grayClass,
				'REPROCESS': yellowClass,
				'APPROVED': greenClass,
				'SENT': greenClass,
				'READED': greenClass
			}[status];

		}
	},
	mounted() {

		EventBus.$on('studentAssigned', (studentsAssigned) => {
			this.student = studentsAssigned;
		});

		EventBus.$on('classChanged', (klass) => {

			this.student = [];

			if (klass && klass.data && klass.data.schoolClassId) {

				this.getStudents({
					userId: this.user.id,
					schoolClassId: this.class.schoolClassId
				}).then(() => {

					if (this.context === 'agenda') {

						this.getAgendaStatus({
							userId: this.user.id,
							schoolClassId: klass.data.schoolClassId,
							date: moment(this.agenda.date).format('YYYY-MM-DD')
						});

					}

				});

			}

		});

	},
	beforeDestroy() {

		EventBus.$off('classChanged');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/student/index.js